export default __webpack_public_path__ + "static/media/asus.514bc349.png";